// Add real merchant logos here, e.g. { name: "Main Street Cafe", src: "/clients/main-street-cafe.png" }
export const CLIENT_LOGOS = [];
